<template>
  <el-card class="settings-card">
    <div class="setting-card-wrap">
      <i class="el-icon-setting card-avatar"></i>
      <div class="setting-card-inner">
        <div class="setting-card-header">
          <span>{{ config.title }}</span>
          <el-button
            type="text"
            @click="settings">去设置</el-button>
        </div>
        <div class="setting-card-info">{{ config.desc }}</div>
      </div>
    </div>
  </el-card>
</template>
<script>
// import Service from '@/utils/service'
export default {
  name: 'SettingsCard',
  props: { config: { type: Object, default: () => {} }},
  // mounted() {
  //   const { topic, k } = this.config
  //   if (topic) {
  //     Service.getkeyvaluebykey({ topic, k })
  //       .then(res => {
  //         console.log(res)
  //       })
  //       .catch(err => {
  //         console.log(err)
  //       })
  //   }
  // },
  methods: {
    settings() {
      this.$emit('setting')
    }
  }
}
</script>
<style lang="stylus" scoped>
.settings-card {
  margin-bottom: 20px;

  .setting-card-wrap {
    display: flex;

    .card-avatar {
      flex: 0 0 36px;
      font-size 36px
      width: 36px;
      height: 36px;
      color: #f56c6c
    }

    .setting-card-inner {
      margin-left: 10px;
      flex: 1;

      .setting-card-header {
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .setting-card-info {
        color: #999;
        font-size: 14px;
        line-height: 20px;
        height: 40px;
        overflow hidden
      }
    }
  }
}
</style>
